import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function authHeader() {
  const token = localStorage.getItem('aurocle_admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const api = {
  createLead: (data) => axios.post(`${API}/leads`, data),
  createBooking: (data) => axios.post(`${API}/bookings`, data),
  createCallback: (data) => axios.post(`${API}/callbacks`, data),

  adminLogin: (data) => axios.post(`${API}/admin/login`, data),
  adminVerify: () => axios.get(`${API}/admin/verify`, { headers: authHeader() }),
  getStats: () => axios.get(`${API}/admin/stats`, { headers: authHeader() }),

  getLeads: (params) => axios.get(`${API}/leads`, { params, headers: authHeader() }),
  getLead: (id) => axios.get(`${API}/leads/${id}`, { headers: authHeader() }),
  updateLead: (id, data) => axios.put(`${API}/leads/${id}`, data, { headers: authHeader() }),
  updateStage: (id, stage) => axios.put(`${API}/leads/${id}/stage`, { stage }, { headers: authHeader() }),
  assignLead: (id, owner) => axios.put(`${API}/leads/${id}/assign`, { owner }, { headers: authHeader() }),
  addNote: (id, data) => axios.post(`${API}/leads/${id}/notes`, data, { headers: authHeader() }),
  addTag: (id, tag) => axios.post(`${API}/leads/${id}/tags`, { tag }, { headers: authHeader() }),
  removeTag: (id, tag) => axios.delete(`${API}/leads/${id}/tags/${tag}`, { headers: authHeader() }),

  getBookings: (params) => axios.get(`${API}/bookings`, { params, headers: authHeader() }),
  getBooking: (id) => axios.get(`${API}/bookings/${id}`, { headers: authHeader() }),
  updateBooking: (id, data) => axios.put(`${API}/bookings/${id}`, data, { headers: authHeader() }),

  getCallbacks: () => axios.get(`${API}/callbacks`, { headers: authHeader() }),

  getNotifications: (params) => axios.get(`${API}/notifications`, { params, headers: authHeader() }),
  markNotifRead: (id) => axios.put(`${API}/notifications/${id}/read`, {}, { headers: authHeader() }),
  markAllNotifsRead: () => axios.put(`${API}/notifications/read-all`, {}, { headers: authHeader() }),

  getTemplates: () => axios.get(`${API}/email-templates`, { headers: authHeader() }),
  updateTemplate: (id, data) => axios.put(`${API}/email-templates/${id}`, data, { headers: authHeader() }),

  exportCSV: (params) => axios.get(`${API}/leads/export/csv`, { params, headers: authHeader(), responseType: 'blob' }),

  getContent: (params) => axios.get(`${API}/content`, { params }),
  getContentBySlug: (slug) => axios.get(`${API}/content/${slug}`),
};
